import { useState, useEffect } from 'react'

const DISMISS_KEY = 'casavio_browser_translate_dismissed'

export default function BrowserTranslateBanner() {
  const [visible, setVisible] = useState(false)
  const [lang, setLang] = useState('other')

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY)) return
    const nav = (navigator.language || '').toLowerCase()
    if (nav.startsWith('en')) return
    setLang(nav.startsWith('es') ? 'es' : 'other')
    setVisible(true)
  }, [])

  if (!visible) return null

  const message = lang === 'es'
    ? '👋 Bienvenido. Casavio funciona en cualquier idioma — haga clic con el botón derecho en cualquier parte de la página y seleccione "Traducir al español" para ver Casavio en su idioma preferido.'
    : '👋 Welcome. Casavio supports any language — right-click anywhere on the page and select "Translate" to view Casavio in your preferred language.'

  function dismiss() {
    localStorage.setItem(DISMISS_KEY, '1')
    setVisible(false)
  }

  return (
    <div style={{
      background: '#FBF3E8',
      borderBottom: '1px solid #E8D8C0',
      padding: '10px 48px 10px 16px',
      fontSize: '13px',
      color: '#5C3D1E',
      fontFamily: 'Calibri, sans-serif',
      lineHeight: '1.5',
      position: 'relative',
    }}>
      {message}
      <button
        onClick={dismiss}
        aria-label="Dismiss"
        style={{
          position: 'absolute',
          right: '12px',
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontSize: '18px',
          color: '#8C6A3C',
          lineHeight: 1,
          padding: '4px',
        }}
      >
        ×
      </button>
    </div>
  )
}
